
import { StateCreator } from 'zustand';
import { GridFilters, GridSearchSlice } from '../gridTypes';
import { setFilterPropertyHandler } from '../gridUtils';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

const initialState: GridFilters = {
    query: "",
    sort: "sortOrder,desc",
    conditionFilter: [],
    sectionFilter: [],
    sizeFilter: [],
    colorFilter: [],
    minPrice: undefined,
    maxPrice: undefined,
    gridReferenceId: undefined,
    parentGridId:undefined,
    universeId: undefined,
    shippingTypeId:[],
    customerStoreId:undefined,
    isInitialState: true,
    pageSize: undefined,
    sellerId: undefined,
    cartCode: undefined,
    categoryId: undefined,
    excludeProductId: undefined,
}


export const createSearchSlice: ImmerStateCreator<GridSearchSlice> = (set) => ({
    gridSearchFilters: initialState,
    originalSearchUniverseId: undefined,
    pendingSearchUniverseId: undefined,
    SET_SEARCH_FILTER: (filterType, newValue) => {
        set((state) => {
            const {gridSearchFilters} = state
            const filterUpdated = setFilterPropertyHandler(gridSearchFilters, filterType, newValue)
            state.gridSearchFilters = {...filterUpdated, isInitialState: false}
        }, false, 'SET_SEARCH_FILTER')
    },
    RESET_SEARCH_FILTER: () => {
        set((state) => {
            state.gridSearchFilters = initialState
        }, false, 'RESET_SEARCH_FILTER')
    },
    SET_QUERY_FILTER: (newQuery) => {
        set((state) => {
            const { gridSearchFilters } = state
            state.gridSearchFilters = { 
                ...gridSearchFilters,     
                sort: initialState.sort,
                conditionFilter: initialState.conditionFilter,
                sectionFilter: initialState.sectionFilter,
                sizeFilter: initialState.sizeFilter,
                colorFilter: initialState.colorFilter,
                minPrice: initialState.minPrice,
                maxPrice: initialState.maxPrice,
                query: newQuery
            }
        }, false, 'SET_QUERY_FILTER')
    },
    SET_ORIGINAL_SEARCH_UNIVERSE: (universeId) => {
        set((state) => {
            state.originalSearchUniverseId = universeId
        }, false, 'SET_ORIGINAL_SEARCH_UNIVERSE')
    },
    SET_PENDING_SEARCH_UNIVERSE: (universeId) => {
        set((state) => {
            state.pendingSearchUniverseId = universeId
        }, false, 'SET_PENDING_SEARCH_UNIVERSE')
    },
    CLEAR_PENDING_SEARCH_UNIVERSE: () => {
        set((state) => {
            state.pendingSearchUniverseId = undefined
        }, false, 'CLEAR_PENDING_SEARCH_UNIVERSE')
    },
});
